module.exports = __webpack_public_path__ + "static/media/icon-warning.d03d2719.svg";